/**
 * Chiziqli tizim A·x = b — Gauss usuli, qismiy tanlash (partial pivoting).
 * Kichik tizimlar uchun (n ≤ ~50). Singular bo'lsa null qaytaradi.
 */
export function linsolve(A: readonly (readonly number[])[], b: readonly number[]): number[] | null {
  const n = b.length;
  // Kengaytirilgan matritsa nusxasi
  const M: number[][] = A.map((row, i) => [...row, b[i] as number]);

  for (let col = 0; col < n; col++) {
    // Pivot tanlash
    let pivot = col;
    let best = Math.abs((M[col] as number[])[col] as number);
    for (let r = col + 1; r < n; r++) {
      const v = Math.abs((M[r] as number[])[col] as number);
      if (v > best) {
        best = v;
        pivot = r;
      }
    }
    if (best < 1e-300 || !Number.isFinite(best)) return null;
    if (pivot !== col) {
      const tmp = M[col] as number[];
      M[col] = M[pivot] as number[];
      M[pivot] = tmp;
    }
    const prow = M[col] as number[];
    const p = prow[col] as number;
    for (let r = col + 1; r < n; r++) {
      const row = M[r] as number[];
      const factor = (row[col] as number) / p;
      if (factor === 0) continue;
      for (let c = col; c <= n; c++) {
        row[c] = (row[c] as number) - factor * (prow[c] as number);
      }
    }
  }

  // Orqaga yurish
  const x = new Array<number>(n).fill(0);
  for (let i = n - 1; i >= 0; i--) {
    const row = M[i] as number[];
    let s = row[n] as number;
    for (let c = i + 1; c < n; c++) s -= (row[c] as number) * (x[c] as number);
    x[i] = s / (row[i] as number);
  }
  return x;
}
